import axios from "axios";
import { Auth } from "aws-amplify";

const GO_SERVER_BASE_API_URLS = {
  development:
    "https://fcba17gw9k.execute-api.us-east-1.amazonaws.com/go-server",
  staging: "https://oo04cuccc6.execute-api.us-east-1.amazonaws.com/go-server",
  production:
    "https://byyhh7s57b.execute-api.us-east-1.amazonaws.com/go-server",
};

const getEnvironment = () => {
  if (import.meta.env.VITE_LOCAL_DEV === "true") {
    return "development";
  }
  if (import.meta.env.VITE_IS_STAGING === "true") {
    return "staging";
  }
  return "production";
};

const GO_SERVER_BASE_API_URL =
  import.meta.env.VITE_LOCAL_DEV === "true"
    ? "http://127.0.0.1:8080/go-server"
    : GO_SERVER_BASE_API_URLS[getEnvironment()];

const goClient = axios.create({
  baseURL: GO_SERVER_BASE_API_URL,
  timeout: 60000,
});

goClient.interceptors.request.use(async (config) => {
  const session = await Auth.currentSession();
  const jwtToken = session.accessToken.jwtToken;

  return {
    ...config,
    headers: {
      ...config.headers,
      Authorization: `Bearer ${jwtToken}`,
    },
  };
});

export default goClient;
